module.exports = __webpack_public_path__ + "static/media/ford-aircraft-lo.7db0fecc.png";